import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import CircularProgress from '@mui/material/CircularProgress'
import Fab from '@mui/material/Fab'

import { Flex, FlexContainer } from 'components/Flex'
import ListItem from 'components/ListItem'
import ListSort from 'components/ListSort'
import Panel from 'components/Panel'
import { orderBy, useDocs } from 'lib/firestore'

import UserDialog from './UserDialog'

export default function UserList({ count }) {
  const [data, setData] = useState(null)
  const [sort, setSort] = useState({ field: 'email', order: 'asc' })
  const { items } = useDocs('admins', orderBy(sort.field, sort.order))

  const handleChangeSort = field => {
    setSort(current => ({
      field,
      order: current.field !== field || current.order === 'desc' ? 'asc' : 'desc',
    }))
  }

  if (!items) {
    return (
      <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </FlexContainer>
    )
  }

  return (
    <Flex>
      <Panel>
        <ListSort
          title={`管理者一覧（全 ${count} 件）`}
          fields={[{ id: 'email', name: 'メールアドレス' }]}
          value={sort}
          onChange={handleChangeSort}
        />
        {items.map(x => (
          <ListItem key={x.id} primary={x.email} onClick={() => setData(x)} />
        ))}
      </Panel>
      <Fab
        color="primary"
        style={{ position: 'fixed', right: 16, bottom: 16 }}
        onClick={() => setData({})}
      >
        <AddIcon />
      </Fab>
      {data && <UserDialog data={data} onClose={() => setData(null)} />}
    </Flex>
  )
}
